export default `
	aside {
		content
	}
	playlist
	paragraph {
		content
	}
`;
